import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import SEO from '@components/seo/SEO';
import { BackTop, Collapse, Drawer } from 'antd';

const { Panel } = Collapse;

// 创建图标封装组件
const SafeIcon = ({ icon: IconName, useFa = true, ...props }) => {
  if (typeof IconName === 'string' && Icon[IconName]) {
    const IconComponent = Icon[IconName];
    return <IconComponent useFa={useFa} {...props} />;
  }
  
  if (typeof IconName === 'function' || typeof IconName === 'object') {
    return <IconName useFa={useFa} {...props} />;
  }
  
  return null;
};

const Faq = () => {
  const [expandedItem, setExpandedItem] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleAccordion = (index) => {
    setExpandedItem(expandedItem === index ? null : index);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <SEO 
        title="常见问题 - 图美啦使用帮助 | 在线图片美化工具"
        description="查看图美啦常见问题解答，了解如何使用我们的图片美化工具，包括格式支持、图片处理、标注功能和隐私保护等信息。"
        keywords="图美啦常见问题,图片美化帮助,图片编辑问题,图片标注帮助,图片处理教程,图片格式支持"
        canonicalUrl="https://snapbeautify.toolooz.com/faq"
      />
      {/* 导航栏 */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-2xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt="图美啦" width="32" height="32" className="mr-2" />
                图美啦
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="Home" size={16} className="mr-1" />
                首页
              </Link>
              <Link to="/quick-start" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="BookOpen" size={16} className="mr-1" />
                快速上手
              </Link>
              <Link to="/about" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="User" size={16} className="mr-1" />
                关于我们
              </Link>
            </nav>
            <div className="flex md:hidden">
              <button 
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
              >
                <SafeIcon icon="Menu" size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* 移动设备导航菜单 */}
        <Drawer
          title="导航菜单"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={250}
        >
          <div className="flex flex-col space-y-4">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Home" size={16} className="mr-1" />
              首页
            </Link>
            <Link 
              to="/quick-start" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="BookOpen" size={16} className="mr-1" />
              快速上手
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="User" size={16} className="mr-1" />
              关于我们
            </Link>
            <Link 
              to="/features" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Star" size={16} className="mr-1" />
              功能介绍
            </Link>
            <Link 
              to="/faq" 
              className="font-medium text-purple-600 dark:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="HelpCircle" size={16} className="mr-1" />
              常见问题
            </Link>
            <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2">
              <Link 
                to="/privacy" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Shield" size={16} className="mr-1" />
                隐私政策
              </Link>
              <Link 
                to="/terms" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="FileText" size={16} className="mr-1" />
                使用条款
              </Link>
              <Link 
                to="/copyright" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Award" size={16} className="mr-1" />
                版权声明
              </Link>
            </div>
          </div>
        </Drawer>
      </header>

      {/* 主要内容区域 */}
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8 text-center text-gray-800 dark:text-white">常见问题</h1>
        <p className="text-center text-gray-600 dark:text-gray-400 mb-12 max-w-3xl mx-auto">
          这里整理了一些用户经常问到的问题，希望能帮你快速解决使用中遇到的困惑。如果没找到你要的答案，可以通过页面底部的联系方式与我们交流。
        </p>
        
        <div className="max-w-4xl mx-auto grid gap-6">
          
          {/* 问题 1 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(0)}
            >
              <span>图美啦需要下载安装吗？</span>
              <SafeIcon
                icon={expandedItem === 0 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 0 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                不需要安装任何软件。图美啦是一个完全基于浏览器的在线工具，你只需要打开网页 https://snap.tumeila.com 就能立即使用。支持Chrome、Firefox、Edge、Safari等主流浏览器。使用时建议用电脑访问，以获得更好的编辑体验。
              </p>
            </div>
          </div>
          
          {/* 问题 2 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(1)}
            >
              <span>图片处理后的质量会降低吗？</span>
              <SafeIcon
                icon={expandedItem === 1 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 1 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                在默认设置下，图美啦不会明显降低图片质量。不过在导出时，你可以根据需要调整导出质量参数。如果你希望保持最高质量，可以在导出时选择"高质量"选项；如果需要文件体积更小，可以适当降低质量参数。总体来说，美化过程本身不会造成明显的质量损失。
              </p>
            </div>
          </div>
          
          {/* 问题 3 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(2)}
            >
              <span>如何给图片添加箭头和文字标注？</span>
              <SafeIcon
                icon={expandedItem === 2 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 2 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                上传图片后，可以在左侧工具栏中找到标注工具。点击箭头图标可以绘制箭头，拖动箭头的起点和终点来调整位置和方向。点击文字图标可以添加文本标注，双击文本框可以编辑内容。还可以通过右侧属性面板调整颜色、粗细、透明度等参数。对于常用的标注样式，可以保存为预设以便下次快速应用。
              </p>
            </div>
          </div>
          
          {/* 问题 4 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(3)}
            >
              <span>支持哪些图片格式？</span>
              <SafeIcon
                icon={expandedItem === 3 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 3 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                图美啦支持常见的图片格式，包括JPG、PNG、WEBP、GIF(静态)和BMP。你可以从这些格式中上传图片，也可以导出为这些格式。如果你上传的是截图，通常是PNG格式，如果是照片，通常是JPG格式。导出时，如果需要保留透明背景，建议选择PNG格式；如果追求更小的文件体积，可以选择WEBP或JPG格式。
              </p>
            </div>
          </div>
          
          {/* 问题 5 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(4)}
            >
              <span>我的图片会被保存在服务器上吗？</span>
              <SafeIcon
                icon={expandedItem === 4 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 4 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                图美啦完全在本地浏览器中处理图片，所有操作都在你的电脑上进行，图片不会上传到任何服务器。这意味着处理速度取决于你的电脑性能，而不是网络速度。同时，这也保证了图片的隐私安全。不过，这也意味着刷新页面或关闭浏览器后，未保存的编辑内容会丢失，所以记得及时导出或保存你的作品。
              </p>
            </div>
          </div>
          
          {/* 问题 6 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(5)}
            >
              <span>可以批量处理多张图片吗？</span>
              <SafeIcon
                icon={expandedItem === 5 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 5 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                目前图美啦主要针对单张图片处理进行了优化。如果需要批量处理多张图片，建议使用以下方法：对第一张图片完成编辑后，保存当前样式设置（背景、边框等）。然后依次处理下一张图片，并应用已保存的设置，这样可以保持所有图片风格一致，同时大大提高处理效率。我们也在考虑在未来版本中添加批量处理功能。
              </p>
            </div>
          </div>
          
          {/* 问题 7 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(6)}
            >
              <span>使用图美啦需要付费吗？</span>
              <SafeIcon
                icon={expandedItem === 6 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 6 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                图美啦是一个完全免费的工具，所有功能都可以无限制地使用，没有水印，也没有隐藏收费项目。我们希望为用户提供一个简单好用的图片美化工具，让大家都能轻松制作出专业效果的图片。如果你觉得图美啦对你有帮助，欢迎将它分享给更多需要的朋友。
              </p>
            </div>
          </div>
          
          {/* 问题 8 */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
            <button
              className="w-full px-6 py-4 text-left font-medium text-gray-800 dark:text-white flex justify-between items-center focus:outline-none"
              onClick={() => toggleAccordion(7)}
            >
              <span>如何恢复误删的元素或撤销操作？</span>
              <SafeIcon
                icon={expandedItem === 7 ? "ChevronUp" : "ChevronDown"}
                className="text-purple-500"
                size={24}
                useFa={true}
              />
            </button>
            <div
              className={`px-6 pt-0 overflow-hidden transition-all duration-300 ${
                expandedItem === 7 ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="text-gray-600 dark:text-gray-400">
                编辑过程中如果需要撤销操作，可以使用编辑器顶部工具栏中的撤销按钮，或者按键盘快捷键Ctrl+Z（Mac上是Command+Z）。如果需要恢复已撤销的操作，可以使用重做按钮或按Ctrl+Y（Mac上是Command+Shift+Z）。图美啦会记录你的编辑历史，这样你可以随时返回到之前的编辑状态。不过需要注意的是，刷新页面后编辑历史会被清空。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 联系我们 */}
      <div className="container mx-auto px-4 py-8 mb-12">
        <div className="max-w-4xl mx-auto bg-purple-100 dark:bg-purple-900/30 rounded-lg p-6">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-white flex items-center">
            <SafeIcon icon="MessageCircle" className="mr-2 text-purple-500 dark:text-purple-400" size={24} useFa={true} />
            还有其他问题？
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            如果上面的内容没有解答你的疑问，欢迎发邮件给我们。我们会认真阅读每一条反馈，尽快回复你的问题。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="mailto:support@tumeila.com" className="inline-flex items-center justify-center bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-colors">
              <SafeIcon icon="Mail" size={18} className="mr-2" useFa={true} />
              发送邮件
            </a>
            <Link to="/quick-start" className="inline-flex items-center justify-center bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 text-gray-800 dark:text-white px-4 py-2 rounded-lg transition-colors">
              <SafeIcon icon="BookOpen" size={18} className="mr-2" useFa={true} />
              查看快速上手
            </Link>
          </div>
        </div>
      </div>

      {/* 页脚区域 */}
      <footer className="bg-gray-800 text-white py-8 mt-auto">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center text-xl font-bold text-white">
                <img src="/favicon.svg" alt="图美啦" width="24" height="24" className="mr-2" />
                图美啦
              </Link>
            </div>
            
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">隐私政策</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">使用条款</Link>
              <Link to="/copyright" className="text-gray-300 hover:text-white transition-colors text-sm">版权声明</Link>
            </div>
            
            <div className="mt-4 md:mt-0 text-gray-400 text-sm">
              © {new Date().getFullYear()} 图美啦 | SnapBeautify
            </div>
          </div>
        </div>
      </footer>
      
      <BackTop>
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg">
          <SafeIcon icon="ChevronUp" size={20} useFa={true} />
        </div>
      </BackTop>
    </div>
  );
};

export default Faq; 